module.exports = __webpack_public_path__ + "media/images/app/become-vendor/Vendor-WhiteBG-5d89753f5e9c8674f91a6cfa2dcf81a9.webp";